import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import CustomDataGrid from '../../../../reusable-components/datagrid/CustomDataGrid';
import { ITEM_HISTORY } from '../../../../reusable-components/datagrid/noFlexCatalogColumns';
import { AwaitButton } from '../../../../reusable-components/await-button';
import Iconify from "../../../../reusable-components/iconify";
import { useSelector } from '../../../../redux/store';
import { HOST_API_URL } from '../../../../config-global';

ItemHistory.propTypes = {
  data: PropTypes.array,
  productId: PropTypes.number
};

export default function ItemHistory({ data, productId }) {
  const isLoading = useSelector((state) => state.catalog.isLoading);

  const CustomLeftToolbar = () => <Grid container direction="row" justifyContent="flex-start" alignItems="flex-end">
      <AwaitButton
        variant="outlined"
        sx={{ mr: 1 }}
        size="small"
        color="secondary"
        onClick={() => window.open(`${HOST_API_URL}Api/DownloadProductHistory?productId=${productId}`, '_blank')}
        startIcon={<Iconify icon="file-icons:microsoft-excel" />}
      >
        Download
      </AwaitButton>
    </Grid>


  return (
    <div>
      <Grid item xs={12}>
        <CustomDataGrid
          gridId="admin-catalog-item-history"
          boxSX={{ width: '100%', height: 'calc(100vh - 260px)' }}
          data={data}
          gridColumns={ITEM_HISTORY}
          isModal
          isLoading={isLoading}
          sort={[
            { field: 'itemId', sort: 'desc' },
            { field: 'logTimeStamp', sort: 'desc' }
          ]}
          CustomLeftToolbar={CustomLeftToolbar}
        />
      </Grid>
    </div>
  );
}
